






































































































































import { Component, Vue, Provide } from "vue-property-decorator";
import { pagnition } from "@/utils/commonConfig";
import { timeFormat, timeFormatMonth } from "@/utils";

@Component({
  name: "systemLog",
})
export default class PerformanceManagement extends Vue {
  @Provide() private id: string = "";
  @Provide() private dates: any = [];
  @Provide() private opCode: string = ""; //操作名
  @Provide() private opTable: string = ""; //操作表
  @Provide() private opUid: string = ""; //操作人ID
  @Provide() private relatedId: string = ""; //关系ID
  @Provide() private month: string = ""; //月份
  @Provide() private pickerOptions: any = {
    onPick: (opt: any) => {},
    start: "00:00",
    step: "00:10",
    end: "23: 50",
  };
  @Provide() private isSearchFormActionDone: boolean = false;
  @Provide() private pagnition: any = pagnition;
  @Provide() private pageIndex: number = 1;
  @Provide() private pageSize: number = 20;
  @Provide() private pagerCount: number = 0;
  @Provide() private resultData: any = [];
  @Provide() private optionsLists: any = []; //操作表
  @Provide() private optionsName: any = []; //操作名
  @Provide() private optionsNameArr: any = []; //总的操作名
  private created() {
    this.getOpLogParams();
    this.getLogList();
  }

  private handleSizeChange(val: any) {
    this.pageSize = Number(val);
    //展示表格数据
    this.searchFormAction();
  }
  private handleCurrentChange(val: any) {
    this.pageIndex = Number(val);
    //展示表格数据
    this.searchFormAction();
  }

  //点击上一页
  private handlePrevChange(val: any) {
    if (this.pageIndex > 0) {
      //展示表格数据
      this.searchFormAction();
    }
  }

  //点击下一页
  private handleNextChange(val: any) {
    //展示表格数据
    this.searchFormAction();
  }
  // lee 获取列表
  private async getLogList() {
    this.pageIndex = 1;
    this.pageSize = 20;
    this.searchFormAction();
  }
  private async searchFormAction() {
    let _arg: any = {
      Page: {
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
      },
      id: this.id, // ID
      opUid: +this.opUid, //操作人ID
      relatedId: +this.relatedId, //关系ID
      opCode: +this.opCode, //操作名
      opTable: this.opTable, //操作表
      month: this.month, //月份
    };
    if (this.dates && this.dates.length > 0) {
      _arg.beginDate = timeFormat(this.dates[0].getTime());
      _arg.endDate = timeFormat(this.dates[1].getTime());
    }
    this.isSearchFormActionDone = true;
    const { getListOpLogReq, getListOpLogRequest }: any = await import(
      "@/request/logging"
    );
    let res = await getListOpLogRequest.handleHttp(getListOpLogReq(_arg), this);
    this.isSearchFormActionDone = res ? res.loading : false;
    if (res && res.right) {
      if (res.pageout || res.total) {
        this.pagerCount = res.total ? res.total : res.pageout.total;
      }
      if (res.oploggersList) {
        this.resultData = res.oploggersList.map((item: any) => {
          item.ctime = timeFormat(Number(item.ctime));
          return item;
        });
      }
    } else {
      this.isSearchFormActionDone = false;
    }
  }
  // 获取OpLogParams
  private async getOpLogParams() {
    const { getListOpLogParamsReq, getListOpLogParamsRequest }: any = await import(
      "@/request/logging"
    );
    let res = await getListOpLogParamsRequest.handleHttp(getListOpLogParamsReq(), this);
    if (res && res.right) {
      this.optionsLists = Object.keys(JSON.parse(res.params));
      this.optionsNameArr = Object.values(JSON.parse(res.params));
    }
  }
  private getIndex(arr: any, item: any) {
    for (var i in arr) {
      if (arr[i] == item) {
        return i;
      }
    }
  }
  // 操作名获取
  private changOperation(val: any) {
    this.opCode = "";
    const len: any = this.getIndex(this.optionsLists, val);
    let optionsNameList: any = [];
    Object.keys(this.optionsNameArr[len]).forEach((v) => {
      let o: any = {};
      o.label = v;
      o.value = this.optionsNameArr[len][v];
      optionsNameList.push(o);
    });
    this.optionsName = optionsNameList;
  }
}
